import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";
// import { DashboardMeasurement_dashboardMeasurement_charger } from "graphql/generated";

interface IProps extends BaseCardProps {
  baseUrl: string;
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}

const SuperchargerCard: FunctionComponent<IProps> = memo(function Supercharger({ data, baseUrl, config, ...rest }) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__supercharger____title",
        defaultMessage: `{count, plural,
          one {Supercharger}
          other {Superchargers}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      image={"/images/svg/rychlonabijeci-stanice.svg"}
      onClick={() => {
        navigate(`${baseUrl}/supercharger${config.id ? `/${config.id}` : ''}`);
      }}
    >
        <StatsTable
          inline
          rows={[
            {
              label: intl.formatMessage({
                id: "dashboard__supercharger__number_in_use",
                defaultMessage: "Number in use now",
              }),
              unit: "",
              decimals: 0,
              // type: "number",
              value: data?.n_in_use,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__supercharger__power_now",
                defaultMessage: "Active power",
              }),
              unit: "kW",
              decimals: 2,
              // type: "number",
              value: data?.active_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__supercharger__kwh_24h",
                defaultMessage: "Charged capacity",
              }),
              unit: "kWh/24h",
              decimals: 1,
              // type: "number",
              value: data?.charge_capacity,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default SuperchargerCard;
